// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-07509aae] .body {
  overflow-y: hidden;
}
.custom-modal[data-v-07509aae] .v--modal-box.v--modal {
  transition: all 0.2s ease-out;
}
.custom-modal[data-v-07509aae] .v--modal-box.v--modal .header {
  padding: 15px 20px 15px 15px;
}
.conference-settings[data-v-07509aae] {
  position: relative;
  color: var(--toolbtn-color);
  font-size: 16px;
  height: auto;
  width: 100%;
  margin: 0;
  padding: 0 6px;
}
.conference-settings[data-v-07509aae] .custom-input-text-placeholder {
  color: var(--modal-text-color) !important;
}
.conference-settings[data-v-07509aae] .custom-input-text-placeholder.up {
  font-size: 0.8em;
  color: var(--dropdown-color) !important;
}
.conference-settings[data-v-07509aae] .custom-select-wrapper {
  width: 47%;
}
.conference-settings[data-v-07509aae] .custom-select-wrapper label {
  margin: 0;
}
.conference-settings[data-v-07509aae] .custom-select-wrapper .custom-select {
  margin-left: 0;
}
.conference-settings[data-v-07509aae] .conf-modes,
.conference-settings[data-v-07509aae] .conf-type {
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
}
.conference-settings[data-v-07509aae] .conf-type .subheader {
  margin-bottom: 6px;
}
.conference-settings[data-v-07509aae] .subheader {
  color: var(--conf-subheader-color);
}
.conference-settings[data-v-07509aae] .subheader::v-deep label.custom-checkbox {
  color: var(--conf-subheader-color);
}
.conference-settings .conf-item[data-v-07509aae] {
  display: flex;
  align-items: flex-end;
  height: 60px;
}
.conference-settings .custom-input-text[data-v-07509aae] {
  width: 100%;
}
.conference-settings .custom-input-text[data-v-07509aae] .non-border-input {
  width: 100%;
}
.conference-settings .schedule[data-v-07509aae] {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.conference-settings .schedule .date-range-picker[data-v-07509aae] {
  width: 100% !important;
}
.conference-settings .conf-auth[data-v-07509aae] {
  flex-direction: row;
}
.conference-settings .conf-settings a[data-v-07509aae] {
  color: var(--modal-elem-color);
  cursor: pointer;
}
.conference-settings .conf-settings a[data-v-07509aae]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
.conference-settings .periodicity .cbtitle[data-v-07509aae] {
  display: flex;
  align-items: flex-end;
  height: 40px;
}
.conference-settings .periodicity[data-v-07509aae] .custom-select-wrapper {
  width: 25% !important;
  font-size: 14px;
}
.conference-settings .periodicity .options[data-v-07509aae] {
  display: flex;
  flex-direction: row;
  padding-top: 6px;
  padding-left: 32px;
}
.conference-settings .periodicity .counterwrapper[data-v-07509aae] {
  display: flex;
  align-items: center;
  margin-left: 34px;
}
.conference-settings .periodicity .counterwrapper input[data-v-07509aae] {
  width: 32px;
  border: 1px solid #f0f0f0;
  margin: 0 2px;
  padding-top: 3px;
  text-align: center;
  caret-color: #aaa;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 600;
  transition-property: all;
  transition-duration: 0.2s;
}
.conference-settings .periodicity .counterwrapper input[data-v-07509aae]:focus {
  border: 1px solid #f0f0f0;
  outline: none;
}
.conference-settings .periodicity .counterwrapper input[data-v-07509aae]::-webkit-outer-spin-button,
.conference-settings .periodicity .counterwrapper input[data-v-07509aae]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.conference-settings .periodicity .counterwrapper .adding[data-v-07509aae],
.conference-settings .periodicity .counterwrapper .subtracting[data-v-07509aae] {
  text-align: center;
  font-size: 24px;
  width: 32px;
  line-height: 1;
  border: 1px solid #f0f0f0;
  cursor: pointer;
  color: var(--modal-elem-color);
}
.conference-settings .periodicity .counterwrapper .adding[data-v-07509aae]:hover,
.conference-settings .periodicity .counterwrapper .subtracting[data-v-07509aae]:hover {
  background: var(--btn-bghover);
}
.conference-settings .periodicity .counterwrapper .adding span[data-v-07509aae],
.conference-settings .periodicity .counterwrapper .subtracting span[data-v-07509aae] {
  margin-left: auto;
  margin-right: auto;
}
.conference-settings .periodicity .counterwrapper .adding span i[data-v-07509aae],
.conference-settings .periodicity .counterwrapper .subtracting span i[data-v-07509aae] {
  padding-top: 2px;
}
.conference-settings .periodicity .counterwrapper span.words-left[data-v-07509aae] {
  margin-right: 4px;
  font-size: 14px;
}
.conference-settings .periodicity .counterwrapper span.words-right[data-v-07509aae] {
  font-size: 14px;
}
.conference-settings .periodicity .weekdays[data-v-07509aae] {
  display: flex;
  margin-top: 12px;
  align-items: baseline;
}
.conference-settings .periodicity .weekdays[data-v-07509aae] label.custom-checkbox {
  font-size: 14px;
  padding-left: 19px;
}
.conference-settings .periodicity .weekdays span.words[data-v-07509aae] {
  font-size: 14px;
  margin-right: 20px;
  padding-left: 34px;
}
.conference-settings .periodicity .weekdays .ccb[data-v-07509aae] {
  margin-right: 12px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/confSettingsBase.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".custom-modal[data-v-07509aae] .body {\n  overflow-y: hidden;\n}\n.custom-modal[data-v-07509aae] .v--modal-box.v--modal {\n  transition: all 0.2s ease-out;\n}\n.custom-modal[data-v-07509aae] .v--modal-box.v--modal .header {\n  padding: 15px 20px 15px 15px;\n}\n.conference-settings[data-v-07509aae] {\n  position: relative;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  height: auto;\n  width: 100%;\n  margin: 0;\n  padding: 0 6px;\n}\n.conference-settings[data-v-07509aae] .custom-input-text-placeholder {\n  color: var(--modal-text-color) !important;\n}\n.conference-settings[data-v-07509aae] .custom-input-text-placeholder.up {\n  font-size: 0.8em;\n  color: var(--dropdown-color) !important;\n}\n.conference-settings[data-v-07509aae] .custom-select-wrapper {\n  width: 47%;\n}\n.conference-settings[data-v-07509aae] .custom-select-wrapper label {\n  margin: 0;\n}\n.conference-settings[data-v-07509aae] .custom-select-wrapper .custom-select {\n  margin-left: 0;\n}\n.conference-settings[data-v-07509aae] .conf-modes,\n.conference-settings[data-v-07509aae] .conf-type {\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n}\n.conference-settings[data-v-07509aae] .conf-type .subheader {\n  margin-bottom: 6px;\n}\n.conference-settings[data-v-07509aae] .subheader {\n  color: var(--conf-subheader-color);\n}\n.conference-settings[data-v-07509aae] .subheader::v-deep label.custom-checkbox {\n  color: var(--conf-subheader-color);\n}\n.conference-settings .conf-item[data-v-07509aae] {\n  display: flex;\n  align-items: flex-end;\n  height: 60px;\n}\n.conference-settings .custom-input-text[data-v-07509aae] {\n  width: 100%;\n}\n.conference-settings .custom-input-text[data-v-07509aae] .non-border-input {\n  width: 100%;\n}\n.conference-settings .schedule[data-v-07509aae] {\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n.conference-settings .schedule .date-range-picker[data-v-07509aae] {\n  width: 100% !important;\n}\n.conference-settings .conf-auth[data-v-07509aae] {\n  flex-direction: row;\n}\n.conference-settings .conf-settings a[data-v-07509aae] {\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.conference-settings .conf-settings a[data-v-07509aae]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n.conference-settings .periodicity .cbtitle[data-v-07509aae] {\n  display: flex;\n  align-items: flex-end;\n  height: 40px;\n}\n.conference-settings .periodicity[data-v-07509aae] .custom-select-wrapper {\n  width: 25% !important;\n  font-size: 14px;\n}\n.conference-settings .periodicity .options[data-v-07509aae] {\n  display: flex;\n  flex-direction: row;\n  padding-top: 6px;\n  padding-left: 32px;\n}\n.conference-settings .periodicity .counterwrapper[data-v-07509aae] {\n  display: flex;\n  align-items: center;\n  margin-left: 34px;\n}\n.conference-settings .periodicity .counterwrapper input[data-v-07509aae] {\n  width: 32px;\n  border: 1px solid #f0f0f0;\n  margin: 0 2px;\n  padding-top: 3px;\n  text-align: center;\n  caret-color: #aaa;\n  color: rgba(0, 0, 0, 0.5);\n  font-weight: 600;\n  transition-property: all;\n  transition-duration: 0.2s;\n}\n.conference-settings .periodicity .counterwrapper input[data-v-07509aae]:focus {\n  border: 1px solid #f0f0f0;\n  outline: none;\n}\n.conference-settings .periodicity .counterwrapper input[data-v-07509aae]::-webkit-outer-spin-button,\n.conference-settings .periodicity .counterwrapper input[data-v-07509aae]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n.conference-settings .periodicity .counterwrapper .adding[data-v-07509aae],\n.conference-settings .periodicity .counterwrapper .subtracting[data-v-07509aae] {\n  text-align: center;\n  font-size: 24px;\n  width: 32px;\n  line-height: 1;\n  border: 1px solid #f0f0f0;\n  cursor: pointer;\n  color: var(--modal-elem-color);\n}\n.conference-settings .periodicity .counterwrapper .adding[data-v-07509aae]:hover,\n.conference-settings .periodicity .counterwrapper .subtracting[data-v-07509aae]:hover {\n  background: var(--btn-bghover);\n}\n.conference-settings .periodicity .counterwrapper .adding span[data-v-07509aae],\n.conference-settings .periodicity .counterwrapper .subtracting span[data-v-07509aae] {\n  margin-left: auto;\n  margin-right: auto;\n}\n.conference-settings .periodicity .counterwrapper .adding span i[data-v-07509aae],\n.conference-settings .periodicity .counterwrapper .subtracting span i[data-v-07509aae] {\n  padding-top: 2px;\n}\n.conference-settings .periodicity .counterwrapper span.words-left[data-v-07509aae] {\n  margin-right: 4px;\n  font-size: 14px;\n}\n.conference-settings .periodicity .counterwrapper span.words-right[data-v-07509aae] {\n  font-size: 14px;\n}\n.conference-settings .periodicity .weekdays[data-v-07509aae] {\n  display: flex;\n  margin-top: 12px;\n  align-items: baseline;\n}\n.conference-settings .periodicity .weekdays[data-v-07509aae] label.custom-checkbox {\n  font-size: 14px;\n  padding-left: 19px;\n}\n.conference-settings .periodicity .weekdays span.words[data-v-07509aae] {\n  font-size: 14px;\n  margin-right: 20px;\n  padding-left: 34px;\n}\n.conference-settings .periodicity .weekdays .ccb[data-v-07509aae] {\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
